import React from 'react'
import LuxPlusExperienceDiscountOfferBanner from 'takeovers/luxplusExperienceDiscountTakeover/components/LuxPlusExperienceDiscountOfferBanner'
import MaldivesCharterTakeoverBackground from './components/MaldivesCharterTakeoverBackground'

const maldivesCharterTakeoverConfig: App.SiteTakeoverConfig = {
  id: 'maldives-charter',
  palette: 'inverse',
  verticals: new Set(['home']),
  backgroundElement: MaldivesCharterTakeoverBackground,
  siteWide: {
    banner: {
      description: <LuxPlusExperienceDiscountOfferBanner withCta />,
      align: 'start',
      logo: undefined,
      exceptedRoutes: ['/:regionCode/lux-plus'],
      hideOnOfferPagesForMobileScreenSize: true,
      showOnHomePage: true,
    },
  },
}

export default maldivesCharterTakeoverConfig
